import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { API } from '../../../../services/axios';
import { URLS } from '../../../../services/urls';
import CLoader from '../../../../components/Loader';
import moment from 'moment';

const ManageCouponForm = ({ toEdit, onSuccess, handleClose }) => {
  const [afterAction, setAfterAction] = useState('');
  const [loading, setLoading] = useState('');

  const { auth } = useSelector((state) => state.auth);

  const { active_agency } = useSelector((state) => state.agencies);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const onSubmit = (data) => {
    let toSend = {
      "code": data.code,
      "amount": data.amount,
      "start_from": data.startDate,
      "end_at": data.endDate,
    };
    

    if (toEdit) {
        setLoading(true);
      API.patch(URLS.COUPON.update((toEdit.id)), toSend)
        .then((resp) => {
          if (onSuccess) {
            onSuccess(resp.data);
          }
          toast.success('Le coupon a bien été modifié');
          setLoading(false);
          reset();
          if (handleClose) {
            handleClose();
          }
        })
        .catch((error) => {
          toast.error(
            error?.response?.data?.detail ??
            error?.response?.data ??
              "Une erreur s'est produite lors de la mise a jour du coupon, veuiller reésayer !"
          );
          setLoading(false);
        });
    } else {
      setLoading(true);
      API.post(URLS.COUPON.create, toSend)
        .then((resp) => {
          reset();
          if (onSuccess) {
            onSuccess(resp.data);
          }
          toast.success('Le coupon a bien été rajouté');
          setLoading(false);
          if (handleClose) {
            handleClose();
          }
        })
        .catch((error) => {
          toast.error(
            error?.response?.data?.detail ??
            error?.response?.data ??
              "Une erreur s'est produite lors de l'ajout du coupon, veuiller reésayer !"
          );
          setLoading(false);
        });
    }
  };

  const handleSetAfterAction = (actionn) => {
    setAfterAction(actionn);

    window.$('#submitCustomerForm3')?.click();
  };

  useEffect(() => {
    if(toEdit){
        reset({
            code: toEdit.code,
            startDate: moment(toEdit.start_from).format('YYYY-MM-DDTHH:MM'),
            endDate: moment(toEdit.end_at).format('YYYY-MM-DDTHH:MM'),
            amount: toEdit.amount,
        })
    }
  }, [toEdit]);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="floatingFirstnameInput">Code du coupon<span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                id="floatingFirstnameInput"
                {...register('code', {required: true})}
                placeholder="COUPONXS"
              />
              {/* <div className="invalid-feedback">
                    Please select a valid state.
                </div> */}
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="floatingLastnameInput">Amount <span className="text-danger">*</span></label>
              <input
                type="number"
                className="form-control"
                id="floatingLastnameInput"
                {...register('amount', {required: true})}
                placeholder="100.0"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="floatingemailInput">Début d'application <span className="text-danger">*</span></label>
              <input
                type="datetime-local"
                className="form-control"
                id="phoneNumber"
                {...register('startDate', {required: true})}
                placeholder=""
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="floatingemailInput">Fin d'application <span className="text-danger">*</span> </label>
              <input
                type="datetime-local"
                className="form-control"
                id="floatingemailInput"
                {...register('endDate', {required: true})}
                placeholder=""
              />
            </div>
          </div>
        </div>
        
        <div className="button-items  d-inline-flex">
          <button hidden className="hidden" id="submitCustomerForm3" type="submit"></button>
          <button
            type="button"
            onClick={() => handleSetAfterAction('CLOSE')}
            className="btn btn-primary w-md waves-effect waves-light d-flex"
          >
            <span className="my-auto">Soumettre</span>{' '}
            <span className="ms-2 d-inline-flex">
              {' '}
              <CLoader size={20} show={afterAction === 'CLOSE' && loading} />{' '}
            </span>
          </button>
          {/* <button
            type="button"
            onClick={() => handleSetAfterAction('DETAILS')}
            className="btn btn-primary w-md waves-effect waves-light d-flex"
          >
            <span className="my-auto">Soumettre et afficher les détails</span>{' '}
            <span className="ms-2 d-inline-flex">
              {' '}
              <CLoader size={20} show={afterAction === 'DETAILS' && loading} />{' '}
            </span>
          </button>
          <button
            type="button"
            onClick={() => handleSetAfterAction('ADD')}
            className="btn btn-primary w-md waves-effect waves-light d-flex"
          >
            <span className="my-auto">Soumettre et en ajouter un autre</span>{' '}
            <span className="ms-2 d-inline-flex">
              {' '}
              <CLoader size={20} show={afterAction === 'ADD' && loading} />{' '}
            </span>
          </button> */}
        </div>
      </form>
    </div>
  );
};

export default ManageCouponForm;
